// Model
import { ApiResponse } from './../models/api-response.model';
import { Dropdown } from './../models/dropdown.model';
// Angular
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// RxJS
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MerchantBankHttpService {

  constructor(private http: HttpClient) { }

  getMerchantBankDeposits(): Observable<Dropdown[]> {
    return this.http.get<ApiResponse>(`/merchantbank?purpose_id=1`).pipe(
      map(res => res.data)
    );
  }

}
